import WaitingOffers from "./WaitingOffers";

export default WaitingOffers;